import {usePublicImageUpload} from '../../../shared';

export const useCategoryGroupImageUpload = () =>
  usePublicImageUpload({
    resourceName: 'Изображение группы категорий',
    notificationKey: 'category-group-image-upload-error',
  });
